<mat-form-field class="chip-list" appearance="fill">
  <mat-label>Principio Ativo</mat-label>
  <mat-chip-grid #chipGrid aria-label="Tags">
    @for (tag of listTags; track tag) {
      <mat-chip-row #chip [selectable]="selectable" [removable]="!tag.isDeleted"
        (removed)="remove(tag)" [matTooltipDisabled]="!tag.isDeleted"
        matTooltip="Principio Ativo removido" [matTooltipPosition]="'above'">
        <span [style.text-decoration]="tag.isDeleted? 'line-through' : 'none'">
          {{tag.allergyName}}
        </span>
        @if (!tag.isDeleted) {
          <button matChipRemove class="btn-remove-chip">
            <mat-icon>cancel</mat-icon>
          </button>
        }
        @if (tag.isDeleted) {
          <button (click)="reintroduce(tag)" class="btn-remove-chip add">
            <mat-icon [style.color]="'rgb(33,33,33, 0.5)'">add_circle</mat-icon>
          </button>
        }
      </mat-chip-row>
    }
    <input placeholder="Procurar Principio Ativo..." #tagInput (keyup)="onKeySearch($event)" [matAutocomplete]="auto"
      [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (tag of filteredTags; track tag) {
        <mat-option [value]="tag">
          {{tag.allergyName}}
        </mat-option>
      }
    </mat-autocomplete>
    @if (isError) {
      <span class="error-message">Escolha uma opção</span>
    }
  </mat-form-field>